<div
    #headerBar
    class="w-full h-[70px] fixed z-[999] bg-[#080808]"
    [ngClass]="[showEnvironmentHint() ? 'top-[30px]' : 'top-0']"
>
    <!-- top part -->
    <div class="h-full ml-[24px] md:ml-[48px] flex items-center justify-between">
        <a
            class="flex flex-row no-underline hover:no-underline items-center"
            [routerLink]="menuRoute()"
            tabindex="0"
            role="link"
            aria-label="Go to menu page"
        >
            <img
                [attr.height]="'32px'"
                [attr.width]="'128px'"
                [src]="'assets/images/healthineers-logo/healthineers-logo-white.svg'"
                alt="Siemens healthineers Logo"
            />
            <!-- TODO: Change Version To Environment Variable -->
            <div class="flex items-baseline ml-8 max-w-[300px]">
                <span class="md:text-white font-siemens-sans-black text-base/[25px] hidden md:block mr-2 truncate">
                    My Digital Lab Assistant
                </span>
                <span class="no-underline hidden md:inline text-[#999999] text-xs/5 whitespace-nowrap">
                    v{{ version }}
                </span>
            </div>
        </a>
        @defer (on idle) {
            <app-header-menu-buttons
                [linkVisible]="linkVisible()"
                [isTaskOwnerOrAdmin]="isTaskOwnerOrAdmin()"
                [isMdlaScopeSelectable]="isMdlaScopeSelectable()"
                [scopeRoute]="scopeRoute()"
                [supportedLanguages]="supportedLanguages()"
            ></app-header-menu-buttons>
        } @placeholder {
            <!-- CSS-based skeleton loading placeholders for menu buttons -->
            <div class="flex flex-row justify-end md:pr-[20px] items-center gap-[15px]">
                <!-- Contact skeleton (desktop only) -->
                <div class="hidden md:block w-[80px] h-[24px] bg-[#333] rounded animate-pulse"></div>
                <!-- Language button skeleton (desktop only) -->
                <div class="hidden md:block w-[60px] h-[34px] bg-[#333] rounded animate-pulse"></div>
                <!-- Settings button skeleton -->
                <div class="w-[34px] h-[34px] bg-[#333] rounded-full animate-pulse"></div>
                <!-- Notification button skeleton -->
                <div class="w-[34px] h-[34px] bg-[#333] rounded-full animate-pulse"></div>
                <!-- User avatar skeleton -->
                <div class="w-[40px] h-[40px] bg-[#333] rounded-full animate-pulse"></div>
            </div>
        }
    </div>
</div>
<!-- TODO: Change Version To Environment Variable -->
<a
    class="fixed pl-[5%] flex items-center h-[50px] w-full bg-[var(--tileBG)] text-[var(--textColor)] font-siemens-sans-black md:hidden z-[999] no-underline"
    [ngClass]="[showEnvironmentHint() ? 'top-[100px]' : 'top-[70px]']"
    [routerLink]="menuRoute()"
    tabindex="0"
    role="link"
    aria-label="Go to menu page"
>
    My Digital Lab Assistant (v{{ version }})
</a>
